import React, { createContext, useContext, useEffect, useState } from 'react'

import { useUserScopedLocalStorage } from '@acorns/web-utils'

import { HIDE_RERUN_SIDE_LEARNTIPS } from 'router/navigation/components/utils'

type LearnTipsContextType = {
  hideRerunLearnTips: boolean
  setHideRerunLearnTips: (hideRerunLearnTips: boolean) => void
}

export const LearnTipsStateContext = createContext<LearnTipsContextType>({
  hideRerunLearnTips: false,
  setHideRerunLearnTips: () => {},
})

export const LearnTipsStateProvider = ({
  children,
}: {
  children: JSX.Element
}) => {
  const { userScopedLocalStorage } = useUserScopedLocalStorage()

  const hideRerunLocalStorageState = JSON.parse(
    userScopedLocalStorage?.getItem(HIDE_RERUN_SIDE_LEARNTIPS) ?? 'false',
  )
  const [hideRerunLearnTips, setHideRerunLearnTips] = useState(
    hideRerunLocalStorageState,
  )

  useEffect(() => {
    setHideRerunLearnTips(hideRerunLocalStorageState)
  }, [hideRerunLocalStorageState])

  return (
    <LearnTipsStateContext.Provider
      value={{
        hideRerunLearnTips,
        setHideRerunLearnTips,
      }}
    >
      {children}
    </LearnTipsStateContext.Provider>
  )
}

export const useLearnTipsState = () => {
  const { hideRerunLearnTips, setHideRerunLearnTips } = useContext(
    LearnTipsStateContext,
  )

  return { hideRerunLearnTips, setHideRerunLearnTips }
}
